import { Container, Row, Col, Form, Table } from 'react-bootstrap';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import DatePicker from '../../../../Admin/components/common/DatePicker';
import moment from 'moment';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import useCreateRule from '../hooks/useCreateRule';

const RuleForm = () => {
  const { t } = useTranslation();
  const {
    schema,
    ruleName,
    setRuleName,
    enrollmentPeriodFrom,
    setEnrollmentPeriodFrom,
    enrollmentPeriodThrough,
    setEnrollmentPeriodThrough,
    effectiveDate,
    setEffectiveDate,
    benefitPlans,
  } = useCreateRule();
  return (
    <Container fluid className="claims-details enrollment-rule-form">
      <Formik
        validationSchema={schema}
        initialValues={{
          ruleName: ruleName,
          enrollmentPeriodFrom: enrollmentPeriodFrom,
          enrollmentPeriodThrough: enrollmentPeriodThrough,
          effectiveDate: effectiveDate,
        }}
        onSubmit={(values) => {
          console.log('values', values);
        }}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          setFieldTouched,
          setFieldValue,
          values,
          touched,
          errors,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Row className="enrollment-rule-row py-4">
              <Col md={5} className="padding-0">
                <h3
                  className={`${
                    touched.ruleName && errors.ruleName && 'form-required'
                  }`}
                >
                  {t(
                    'admin.pages.enrollment_rules.create_rules.rule_form.rule_name.title',
                  )}
                </h3>
                <p className="description">
                  {t(
                    'admin.pages.enrollment_rules.create_rules.rule_form.rule_name.description',
                  )}
                </p>
              </Col>
              <Col md={7} className="pr-0">
                <Form.Group controlId="ruleName">
                  <Form.Label className="document-labels mb-0">
                    {t(
                      'admin.pages.enrollment_rules.create_rules.rule_form.rule_name.title',
                    )}
                    <span className="form-required" aria-hidden={true}>
                      {` * `}
                    </span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="ruleName"
                    placeholder={`Enter ${t(
                      'admin.pages.enrollment_rules.create_rules.rule_form.rule_name.title',
                    )}`}
                    className=""
                    value={values.ruleName ?? ''}
                    spellCheck="off"
                    autoCorrect="off"
                    autoComplete="off"
                    autoFocus={false}
                    onBlur={(e) => {
                      handleBlur(e);
                      const storeTitle = e.currentTarget.value.trim();
                      setFieldValue('ruleName', storeTitle);
                    }}
                    onChange={(e) => {
                      const storeTitle = e.currentTarget.value.trim();
                      setFieldTouched('ruleName');
                      handleChange(e);
                      setRuleName(storeTitle);
                    }}
                    isInvalid={touched.ruleName && errors.ruleName}
                    aria-required={true}
                    aria-invalid={errors.ruleName ? true : null}
                    aria-describedby="err_title"
                  />
                  <Form.Control.Feedback
                    type="invalid"
                    aria-live="polite"
                    id="err_title"
                    role="alert"
                  >
                    <span>{touched.ruleName && errors.ruleName}</span>
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row className="enrollment-rule-row py-4">
              <Col md={5} className="padding-0">
                <h3
                  className={`${
                    touched.enrollmentPeriodFrom &&
                    errors.enrollmentPeriodFrom &&
                    'form-required'
                  }`}
                >
                  {t(
                    'admin.pages.enrollment_rules.create_rules.rule_form.enrollment_period.title',
                  )}
                </h3>
                <p className="description">
                  {t(
                    'admin.pages.enrollment_rules.create_rules.rule_form.enrollment_period.description',
                  )}
                </p>
              </Col>
              <Col md={7} className="d-flex justify-content-between pr-0">
                <div className="date-container">
                  <Form.Group controlId="enrollmentPeriodFrom">
                    <Form.Label className="document-labels mb-0">
                      {t(
                        'admin.pages.enrollment_rules.create_rules.rule_form.enrollment_period.from_label',
                      )}
                      {/*<span className="form-required" aria-hidden={true}>
                        {` * `}
                      </span> */}
                    </Form.Label>
                    <DatePicker
                      name="enrollmentPeriodFrom"
                      placeholder="Select"
                      showIcon={true}
                      isDOB={false}
                      value={values.enrollmentPeriodFrom}
                      onChange={(date) => {
                        if (date) {
                          //const formatedDate =
                          //moment(date).format('YYYY-MM-DD');
                          setFieldValue('enrollmentPeriodFrom', date);
                          setEnrollmentPeriodFrom(date);
                        } else {
                          setFieldValue('enrollmentPeriodFrom', '');
                        }
                        console.log('date', date);
                        console.log('errors', errors);
                        console.log('touched', touched);
                      }}
                      onBlur={(e) => {
                        handleBlur(e);
                      }}
                    />
                    <Form.Control.Feedback
                      type="invalid"
                      aria-live="polite"
                      id="err_dob"
                      role="alert"
                    >
                      <span>
                        {touched.enrollmentPeriodFrom &&
                          errors.enrollmentPeriodFrom}
                      </span>
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>
                <div className="date-container">
                  <Form.Group controlId="enrollmentPeriodThrough">
                    <Form.Label className="document-labels mb-0">
                      {t(
                        'admin.pages.enrollment_rules.create_rules.rule_form.enrollment_period.through_label',
                      )}
                      {/*<span className="form-required" aria-hidden={true}>
                        {` * `}
                      </span> */}
                    </Form.Label>
                    <DatePicker
                      name="enrollmentPeriodThrough"
                      placeholder="Select"
                      showIcon={true}
                      isDOB={true}
                      value={values.enrollmentPeriodThrough}
                      onChange={(date) => {
                        if (date) {
                          //const formatedDate =
                          //moment(date).format('YYYY-MM-DD');
                          setFieldValue('enrollmentPeriodThrough', date);
                          setEnrollmentPeriodThrough(date);
                        } else {
                          setFieldValue('enrollmentPeriodThrough', '');
                        }
                      }}
                      onBlur={(e) => {
                        handleBlur(e);
                      }}
                    />
                    <Form.Control.Feedback
                      type="invalid"
                      aria-live="polite"
                      id="err_dob"
                      role="alert"
                    >
                      <span>
                        {touched.enrollmentPeriodThrough &&
                          errors.enrollmentPeriodThrough}
                      </span>
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>
              </Col>
            </Row>
            <Row className="enrollment-rule-row py-4">
              <Col md={5} className="padding-0">
                <h3
                  className={`${
                    touched.effectiveDate &&
                    errors.effectiveDate &&
                    'form-required'
                  }`}
                >
                  {t(
                    'admin.pages.enrollment_rules.create_rules.rule_form.effective_date.title',
                  )}
                </h3>
                <p className="description">
                  {t(
                    'admin.pages.enrollment_rules.create_rules.rule_form.effective_date.description',
                  )}
                </p>
              </Col>
              <Col
                md={7}
                className="d-flex justify-content-between align-items-center pr-0"
              >
                <div className="date-container">
                  <Form.Group controlId="effectiveDate">
                    <Form.Label className="document-labels mb-0">
                      {t(
                        'admin.pages.enrollment_rules.create_rules.rule_form.effective_date.date_label',
                      )}
                      <span className="form-required" aria-hidden={true}>
                        {` * `}
                      </span>
                    </Form.Label>
                    <DatePicker
                      name="effectiveDate"
                      className={
                        touched.effectiveDate &&
                        errors.effectiveDate &&
                        'is-invalid'
                      }
                      showIcon={true}
                      isDOB={true}
                      value={values.effectiveDate}
                      onChange={(date) => {
                        if (date) {
                          //const formatedDate =
                          //moment(date).format('YYYY-MM-DD');
                          setFieldValue('effectiveDate', date);
                          setEffectiveDate(date);
                        } else {
                          setFieldValue('effectiveDate', '');
                        }
                      }}
                      onBlur={(e) => {
                        handleBlur(e);
                      }}
                    />
                    <Form.Control.Feedback
                      type="invalid"
                      aria-live="polite"
                      id="err_dob"
                      role="alert"
                    >
                      <span>
                        {touched.effectiveDate && errors.effectiveDate}
                      </span>
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>
                <div className="date-container mt-3">
                  <div className="fetchPlanButton">
                    <GenericButton variant="secondary" className="add-btn">
                      {t(
                        'admin.pages.enrollment_rules.create_rules.rule_form.reload_plan_button',
                      )}
                    </GenericButton>
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="enrollment-rule-row py-4">
              <Col md={5} className="padding-0">
                <h3 className={`${!benefitPlans.length && 'form-required'}`}>
                  {t(
                    'admin.pages.enrollment_rules.create_rules.rule_form.benefit_plans.title',
                  )}
                </h3>
                <p className="description">
                  {t(
                    'admin.pages.enrollment_rules.create_rules.rule_form.benefit_plans.description1',
                  )}
                </p>
                <p className="description">
                  {t(
                    'admin.pages.enrollment_rules.create_rules.rule_form.benefit_plans.description2',
                  )}
                </p>
              </Col>
              <Col md={7} className="setup-form w-100 pr-0">
                <div>
                  <Table
                    striped
                    bordered
                    hover
                    className="benefit-plans-table m-0"
                  >
                    <thead>
                      <tr>
                        <th style={{ textAlign: 'left' }}>Show/Hide</th>
                        <th style={{ textAlign: 'left' }}>Benefit Plans</th>
                        <th style={{ textAlign: 'left' }}>Effective Date</th>
                        <th style={{ textAlign: 'left' }}>Type</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="text-center">
                          <Form.Group
                            id="formGridresetFirstName"
                            className="m-0"
                          >
                            <Form.Label
                              className="sr-only"
                              for="Gold PPO Healthcare Plan"
                            ></Form.Label>
                            <Form.Check
                              type="checkbox"
                              checked={values.spouse}
                              onChange={() => {}}
                              id="Gold PPO Healthcare Plan"
                              name="Gold PPO Healthcare Plan"
                            />
                          </Form.Group>
                        </td>
                        <td className="text-left">
                          <GenericButton variant="link" className="">
                            Gold PPO Healthcare Plan
                          </GenericButton>
                        </td>
                        <td className="text-left">12/21/2023</td>
                        <td className="text-left">Medical</td>
                      </tr>
                      <tr>
                        <td className="text-center">
                          <Form.Group
                            id="formGridresetFirstName"
                            className="m-0"
                          >
                            <Form.Label
                              className="sr-only"
                              for="Gold PPO Healthcare Plan"
                            ></Form.Label>
                            <Form.Check
                              type="checkbox"
                              checked={values.spouse}
                              onChange={() => {}}
                              id="Gold PPO Healthcare Plan"
                              name="Gold PPO Healthcare Plan"
                            />
                          </Form.Group>
                        </td>
                        <td className="text-left">
                          <GenericButton variant="link" className="">
                            Silver Health Maintenance Plus
                          </GenericButton>
                        </td>
                        <td className="text-left">12/23/2023</td>
                        <td className="text-left">Medical</td>
                      </tr>
                      <tr>
                        <td className="text-center">
                          <Form.Group
                            id="formGridresetFirstName"
                            className="m-0"
                          >
                            <Form.Label
                              className="sr-only"
                              for="Gold PPO Healthcare Plan"
                            ></Form.Label>
                            <Form.Check
                              type="checkbox"
                              checked={values.spouse}
                              onChange={() => {}}
                              id="Gold PPO Healthcare Plan"
                              name="Gold PPO Healthcare Plan"
                            />
                          </Form.Group>
                        </td>
                        <td className="text-left">
                          <GenericButton variant="link" className="">
                            Platinum Indemnity Health Plan
                          </GenericButton>
                        </td>
                        <td className="text-left">12/09/2022</td>
                        <td className="text-left">Medical</td>
                      </tr>
                      <tr>
                        <td className="text-center">
                          <Form.Group
                            id="formGridresetFirstName"
                            className="m-0"
                          >
                            <Form.Label
                              className="sr-only"
                              for="Gold PPO Healthcare Plan"
                            ></Form.Label>
                            <Form.Check
                              type="checkbox"
                              checked={values.spouse}
                              onChange={() => {}}
                              id="Gold PPO Healthcare Plan"
                              name="Gold PPO Healthcare Plan"
                            />
                          </Form.Group>
                        </td>
                        <td className="text-left">
                          <GenericButton variant="link" className="">
                            Catastrophic Healthcare Plan
                          </GenericButton>
                        </td>
                        <td className="text-left">12/11/2022</td>
                        <td className="text-left">Dental</td>
                      </tr>
                      <tr>
                        <td className="text-center">
                          <Form.Group
                            id="formGridresetFirstName"
                            className="m-0"
                          >
                            <Form.Label
                              className="sr-only"
                              for="Gold PPO Healthcare Plan"
                            ></Form.Label>
                            <Form.Check
                              type="checkbox"
                              checked={values.spouse}
                              onChange={() => {}}
                              id="Gold PPO Healthcare Plan"
                              name="Gold PPO Healthcare Plan"
                            />
                          </Form.Group>
                        </td>
                        <td className="text-left">
                          <GenericButton variant="link" className="">
                            Gold PPO Healthcare Plan for NY
                          </GenericButton>
                        </td>
                        <td className="text-left">12/12/2021</td>
                        <td className="text-left">Medical</td>
                      </tr>
                      <tr>
                        <td className="text-center">
                          <Form.Group
                            id="formGridresetFirstName"
                            className="m-0"
                          >
                            <Form.Label
                              className="sr-only"
                              for="Gold PPO Healthcare Plan"
                            ></Form.Label>
                            <Form.Check
                              type="checkbox"
                              checked={values.spouse}
                              onChange={() => {}}
                              id="Gold PPO Healthcare Plan"
                              name="Gold PPO Healthcare Plan"
                            />
                          </Form.Group>
                        </td>
                        <td className="text-left">
                          <GenericButton variant="link" className="">
                            Dental Cover Plus
                          </GenericButton>
                        </td>
                        <td className="text-left">12/11/2023</td>
                        <td className="text-left">Dental</td>
                      </tr>
                      <tr>
                        <td className="text-center">
                          <Form.Group
                            id="formGridresetFirstName"
                            className="m-0"
                          >
                            <Form.Label
                              className="sr-only"
                              for="Gold PPO Healthcare Plan"
                            ></Form.Label>
                            <Form.Check
                              type="checkbox"
                              checked={values.spouse}
                              onChange={() => {}}
                              id="Gold PPO Healthcare Plan"
                              name="Gold PPO Healthcare Plan"
                            />
                          </Form.Group>
                        </td>
                        <td className="text-left">
                          <GenericButton variant="link" className="">
                            Silver Health Maintenance Plan
                          </GenericButton>
                        </td>
                        <td className="text-left">12/10/2023</td>
                        <td className="text-left">Medical</td>
                      </tr>
                      <tr>
                        <td className="text-center">
                          <Form.Group
                            id="formGridresetFirstName"
                            className="m-0"
                          >
                            <Form.Label
                              className="sr-only"
                              for="Gold PPO Healthcare Plan"
                            ></Form.Label>
                            <Form.Check
                              type="checkbox"
                              checked={values.spouse}
                              onChange={() => {}}
                              id="Gold PPO Healthcare Plan"
                              name="Gold PPO Healthcare Plan"
                            />
                          </Form.Group>
                        </td>
                        <td className="text-left">
                          <GenericButton variant="link" className="">
                            Vision Plus Insurance
                          </GenericButton>
                        </td>
                        <td className="text-left">12/09/2023</td>
                        <td className="text-left">Vision</td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row>
            <Row>
              <Col className="pr-0">
                <div className="d-flex justify-content-end mt-4">
                  <GenericButton
                    type="submit"
                    variant="primary"
                    tabIndex={0}
                    ariaLabel="Click send button to upload document information"
                  >
                    {t(
                      'admin.pages.enrollment_rules.create_rules.rule_form.save_button',
                    )}
                  </GenericButton>
                </div>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </Container>
  );
};

export default RuleForm;
